module.exports = __webpack_public_path__ + "static/media/memorial_bw.f327b847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/memorial_bw.jpg
// module id = 460
// module chunks = 0